module.exports = __webpack_public_path__ + "static/media/1_pl.bb4df4f8.png";